<template>
  <div class="nyheter">
    <!-- 背景图区域 -->
    <div class="banner">
      <div class="title-container">
        <h1 class="main-title">NYHETER</h1>
        <h2 class="sub-title">LISTA</h2>
      </div>
    </div>

    <!-- 可点击列表 -->
    <div class="news-list">
      <div 
        v-for="(item, index) in listItems"
        :key="index"
        class="list-item"
        @click="handleItemClick(index)"
      >
        {{ item.text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NyheterPage",
  data() {
    return {
      listItems: [
        { text: "Became a student of China national acupuncture academician\n成为中国国家针灸院士的学生" },
        { text: "China Jiangxi University of Traditional Chinese Medicine graduate training base\n中国江西中医药大学研究生培训基地" },
        { text: "Professor Guo visited Hebei Hospital of Traditional Chinese Medicine\n郭教授访问河北中医医院" },
        { text: "Dean of China Xinjiang Medical University came and visited\n中国新疆医科大学院长来访" },
        { text: "Dean of Henan University of Chinese Medicine visited Prof.Guo.Klinik\n河南中医药大学院长访问郭教授诊所" },
        { text: "Third National Academic Report of Diffcult Dianosis and treatment meeting\n第三届疑难病诊治学术报告会" },
        { text: "The very popular health lecture\n广受欢迎的健康讲座" },
        { text: "Working together with the national master of Chinese Medicine\n与中国中医大师合作" }
      ]
    };
  },
  methods: {
    handleItemClick(index) {
      this.$router.push(`/nyheterDetail/${index + 1}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.nyheter {
  min-width: 1200px; 
  width: 1200px; 
    padding: 20px;
  height: 100vh;

  .banner {
    background-image: url('@/assets/bg.png');
    background-size: cover;
    background-position: center;
    padding: 40px;
    margin-bottom: 40px;
    color: black; /* 将字体颜色改为黑色 */
  }

  .title-container {
    position: relative;
    padding-left: 20px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 4px;
      background: #2e7d32;
    }

    .main-title {
      font-size: 2.5rem;
      color: #2c3e50;
      margin-bottom: 10px;
    }

    .sub-title {
      font-size: 1.2rem;
      color: #666;
      margin: 0;
    }
  }

  .news-list {
    flex: 1;
    padding: 20px 10%;

    .list-item {
      padding: 15px 20px;
      border-bottom: 1px solid #eee;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        background: #f8f8f8;
        transform: translateX(10px);
      }
    }
  }
}
@media (max-width: 768px) {
    .nyheter {
        min-width: unset;
        width: 100%;
        padding: 10px;
        height: auto;
        
        .banner {
            padding: 20px;
            margin-bottom: 20px;
            
            .title-container {
                padding-left: 15px;
                
                .main-title {
                    font-size: 1.8rem;
                }
                
                .sub-title {
                    font-size: 1rem;
                }
            }
        }
        
        .news-list {
            padding: 10px 5%;
            
            .list-item {
                padding: 12px 15px;
                font-size: 0.9rem;
                white-space: normal;
                line-height: 1.4;
                
                &:hover {
                    transform: none;
                }
            }
        }
    }
}
</style>